var a={disabled:!1};export{a as default};
//# sourceMappingURL=config.js.map
